(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papelia-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PapeliaInfiniteGallery) {
      window.PapeliaInfiniteGallery.init(document);
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const selector = '[data-papelia-infinite-gallery-track]';

    const initTrack = (shell) => {
      if (shell.dataset.infiniteGalleryInitialized === 'true') return;

      const viewport = shell.querySelector('.papelia-gallery__viewport');
      const track = shell.querySelector('.papelia-gallery__track');
      const previous = shell.querySelector('[data-gallery-prev]');
      const next = shell.querySelector('[data-gallery-next]');
      if (!viewport || !track) return;

      const originals = Array.from(track.children).filter((item) => item.matches('.papelia-gallery__card'));
      if (originals.length < 2) {
        if (previous) previous.disabled = true;
        if (next) next.disabled = true;
        return;
      }

      shell.dataset.infiniteGalleryInitialized = 'true';
      originals.forEach((item) => { item.dataset.galleryOriginal = 'true'; });

      let frame = 0;
      let lastTime = 0;
      let visible = false;
      let ready = false;
      let manualTimer = 0;
      let interactionTimer = 0;
      let resizeTimer = 0;
      let activePointerId = null;
      let mouseDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      const pauseReasons = new Set();
      const autoplay = shell.dataset.autoplay === 'true';
      const direction = shell.dataset.direction === 'reverse' ? -1 : 1;

      const currentSpeed = () => {
        const value = desktopMedia.matches ? shell.dataset.speedDesktop : shell.dataset.speedMobile;
        return Math.max(2, Number(value) || 24);
      };

      const cloneCard = (item, group) => {
        const clone = item.cloneNode(true);
        clone.removeAttribute('data-gallery-original');
        clone.dataset.galleryClone = group;
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      };

      const metrics = () => {
        const firstOriginal = track.querySelector('[data-gallery-original]');
        const firstAfter = track.querySelector('[data-gallery-clone="after"]');
        if (!firstOriginal || !firstAfter) return null;
        const cycle = firstAfter.offsetLeft - firstOriginal.offsetLeft;
        if (cycle <= 0) return null;
        return { start: firstOriginal.offsetLeft, cycle };
      };

      const normalize = (force = false) => {
        const currentMetrics = metrics();
        if (!currentMetrics) return;
        if (force) {
          viewport.scrollLeft = currentMetrics.start;
          return;
        }
        let position = viewport.scrollLeft;
        while (position < currentMetrics.start) position += currentMetrics.cycle;
        while (position >= currentMetrics.start + currentMetrics.cycle) position -= currentMetrics.cycle;
        if (Math.abs(position - viewport.scrollLeft) > 0.5) viewport.scrollLeft = position;
      };

      const shouldAnimate = () => autoplay && visible && pauseReasons.size === 0 && !document.hidden && !reducedMotion.matches && ready;

      const tick = (time) => {
        const elapsed = lastTime ? Math.min((time - lastTime) / 1000, 0.08) : 0;
        lastTime = time;
        viewport.scrollLeft += direction * currentSpeed() * elapsed;
        normalize();
        frame = requestAnimationFrame(tick);
      };

      const updateAnimation = () => {
        const play = shouldAnimate();
        shell.classList.toggle('papelia-gallery__track-shell--playing', play);
        if (play && !frame) {
          lastTime = 0;
          frame = requestAnimationFrame(tick);
        } else if (!play && frame) {
          cancelAnimationFrame(frame);
          frame = 0;
          lastTime = 0;
        }
      };

      const setPaused = (reason, value) => {
        if (value) pauseReasons.add(reason);
        else pauseReasons.delete(reason);
        updateAnimation();
      };

      const centeredCardTarget = (step) => {
        const cards = Array.from(track.querySelectorAll('.papelia-gallery__card'));
        if (!cards.length) return viewport.scrollLeft;
        const viewportCenter = viewport.scrollLeft + (viewport.clientWidth / 2);
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
          const distance = Math.abs(cardCenter - viewportCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        const targetIndex = Math.max(0, Math.min(cards.length - 1, nearestIndex + step));
        const target = cards[targetIndex];
        return target.offsetLeft + (target.offsetWidth / 2) - (viewport.clientWidth / 2);
      };

      const move = (step) => {
        setPaused('manual', true);
        normalize();
        if (desktopMedia.matches) {
          viewport.scrollBy({ left: step * viewport.clientWidth * 0.78, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        } else {
          viewport.scrollTo({ left: centeredCardTarget(step), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
        window.clearTimeout(manualTimer);
        manualTimer = window.setTimeout(() => {
          normalize();
          setPaused('manual', false);
        }, reducedMotion.matches ? 40 : 520);
      };

      const buildLoop = () => {
        const first = originals[0];
        const last = originals[originals.length - 1];
        const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        const cycleWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;
        if (cycleWidth <= 0) return;

        const copies = Math.max(2, Math.ceil(viewport.clientWidth / cycleWidth) + 1);
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        for (let index = 0; index < copies; index += 1) {
          originals.forEach((item) => before.appendChild(cloneCard(item, 'before')));
          originals.forEach((item) => after.appendChild(cloneCard(item, 'after')));
        }
        track.prepend(before);
        track.append(after);
        ready = true;
        requestAnimationFrame(() => {
          normalize(true);
          updateAnimation();
        });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          move(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          move(1);
        }
      });
      shell.addEventListener('mouseenter', () => {
        if (desktopMedia.matches) setPaused('hover', true);
      });
      shell.addEventListener('mouseleave', () => setPaused('hover', false));
      shell.addEventListener('focusin', () => {
        setPaused('focus', desktopMedia.matches && Boolean(shell.querySelector(':focus-visible')));
      });
      shell.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          setPaused('focus', desktopMedia.matches && Boolean(shell.querySelector(':focus-visible')));
        });
      });
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        window.clearTimeout(interactionTimer);
        shell.classList.add('is-interacting');
        setPaused('pointer', true);
        activePointerId = event.pointerId;
        mouseDragging = event.pointerType !== 'touch';
        if (mouseDragging) {
          dragStartX = event.clientX;
          dragStartScrollLeft = viewport.scrollLeft;
          viewport.setPointerCapture?.(event.pointerId);
          event.preventDefault();
        }
      });
      const dragTo = (clientX, event) => {
        if (!mouseDragging || activePointerId === null) return;
        event.preventDefault();
        viewport.scrollLeft = dragStartScrollLeft - (clientX - dragStartX);
      };
      viewport.addEventListener('pointermove', (event) => dragTo(event.clientX, event), { passive: false });
      viewport.addEventListener('mousemove', (event) => dragTo(event.clientX, event), { passive: false });
      const releasePointer = (event) => {
        if (activePointerId === null) return;
        if (typeof event.pointerId === 'number' && event.pointerId !== activePointerId) return;
        if (mouseDragging && viewport.hasPointerCapture?.(activePointerId)) {
          viewport.releasePointerCapture(activePointerId);
        }
        activePointerId = null;
        mouseDragging = false;
        window.clearTimeout(interactionTimer);
        interactionTimer = window.setTimeout(() => {
          shell.classList.remove('is-interacting');
          normalize();
          setPaused('pointer', false);
        }, 120);
      };
      viewport.addEventListener('pointerup', releasePointer);
      viewport.addEventListener('pointercancel', releasePointer);
      window.addEventListener('mouseup', releasePointer);
      viewport.addEventListener('dragstart', (event) => event.preventDefault());
      viewport.addEventListener('contextmenu', (event) => event.preventDefault());
      viewport.addEventListener('selectstart', (event) => event.preventDefault());
      desktopMedia.addEventListener('change', (event) => {
        if (!event.matches) setPaused('hover', false);
        updateAnimation();
      });
      document.addEventListener('visibilitychange', updateAnimation);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          updateAnimation();
        }, { rootMargin: '80px 0px', threshold: 0.12 });
        observer.observe(shell.closest('#papelia-gallery') || shell);
      } else {
        visible = true;
      }

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          if (!ready) return;
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(() => normalize(true), 120);
        });
        resizeObserver.observe(viewport);
      }

      const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
      fontsReady.then(() => requestAnimationFrame(buildLoop));
    };

    const init = (root = document) => {
      root.querySelectorAll(selector).forEach(initTrack);
    };

    window.PapeliaInfiniteGallery = { init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papelia-pricing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PapeliaExclusiveCheckout) {
      window.PapeliaExclusiveCheckout.init(document);
      return;
    }

    const initSection = (section) => {
      if (section.dataset.exclusiveCheckoutInitialized === 'true') return;
      section.dataset.exclusiveCheckoutInitialized = 'true';

      const forms = section.querySelectorAll('[data-papelia-exclusive-form]');
      const dialog = section.querySelector('[data-papelia-upsell-dialog]');
      const acceptButton = dialog?.querySelector('[data-upsell-accept]');
      const cancelButton = dialog?.querySelector('[data-upsell-cancel]');
      const declineButtons = dialog ? Array.from(dialog.querySelectorAll('[data-upsell-decline]')) : [];
      const modalStatus = dialog?.querySelector('[data-upsell-status]');
      const upsellVariantId = Number(section.dataset.upsellVariantId || 0);
      const upsellReady = section.dataset.upsellReady === 'true' && upsellVariantId > 0 && Boolean(dialog);
      const root = window.Shopify?.routes?.root || '/';
      let pending = null;
      let busy = false;

      const setButtonLoading = (button, loading) => {
        if (!button) return;
        button.dataset.loading = String(loading);
        button.disabled = loading;
      };

      const request = async (path, options) => {
        const response = await fetch(`${root}${path}`, options);
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || payload.message || 'No fue posible preparar tu compra.');
        return payload;
      };

      const clearCart = () => request('cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });

      const addItems = (items) => request('cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      const replaceCart = async (mainVariantId, includeUpsell) => {
        await clearCart();
        const mainItem = { id: mainVariantId, quantity: 1 };
        const items = [mainItem];
        if (includeUpsell) items.push({ id: upsellVariantId, quantity: 1 });
        try {
          await addItems(items);
        } catch (error) {
          if (!includeUpsell) throw error;
          await clearCart();
          await addItems([mainItem]);
        }
      };

      const unlockPending = () => {
        if (!pending) return;
        setButtonLoading(pending.button, false);
        pending.button.disabled = false;
      };

      const cancelPurchase = () => {
        if (busy) return;
        const trigger = pending?.button;
        const restoreScrollY = pending?.scrollY;
        if (modalStatus) modalStatus.textContent = '';
        setButtonLoading(acceptButton, false);
        declineButtons.forEach((button) => { button.disabled = false; });
        if (cancelButton) cancelButton.disabled = false;
        unlockPending();
        pending = null;
        if (dialog?.open) dialog.close();
        if (Number.isFinite(restoreScrollY)) window.scrollTo({ top: restoreScrollY, behavior: 'auto' });
        trigger?.focus({ preventScroll: true });
      };

      const finishPurchase = async (includeUpsell) => {
        if (!pending || busy) return;
        busy = true;
        if (modalStatus) modalStatus.textContent = '';
        if (pending.status) pending.status.textContent = '';
        declineButtons.forEach((button) => { button.disabled = true; });
        if (cancelButton) cancelButton.disabled = true;
        if (dialog?.open) {
          setButtonLoading(acceptButton, true);
        } else {
          setButtonLoading(pending.button, true);
        }

        try {
          await replaceCart(pending.variantId, includeUpsell);
          const destination = section.dataset.purchaseMode === 'cart' ? `${root}cart` : `${root}checkout`;
          window.location.assign(destination);
        } catch (error) {
          const message = error instanceof Error ? error.message : 'Ocurrió un error. Inténtalo de nuevo.';
          if (dialog?.open && modalStatus) modalStatus.textContent = message;
          if (pending.status) pending.status.textContent = message;
          setButtonLoading(acceptButton, false);
          declineButtons.forEach((button) => { button.disabled = false; });
          if (cancelButton) cancelButton.disabled = false;
          unlockPending();
          busy = false;
        }
      };

      const openUpsell = () => {
        if (!dialog || typeof dialog.showModal !== 'function') {
          finishPurchase(false);
          return;
        }
        if (modalStatus) modalStatus.textContent = '';
        if (cancelButton) cancelButton.disabled = false;
        pending.button.dataset.loading = 'false';
        pending.button.disabled = true;
        dialog.showModal();
        requestAnimationFrame(() => acceptButton?.focus());
      };

      forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (busy) return;
          const button = form.querySelector('[type="submit"]');
          const status = form.querySelector('[data-papelia-form-status]');
          const idInput = form.elements.namedItem('id');
          const variantId = Number(idInput?.value || 0);
          if (!button || button.disabled || variantId <= 0) return;
          pending = { button, status, variantId, scrollY: window.scrollY };
          if (upsellReady) {
            openUpsell();
          } else {
            finishPurchase(false);
          }
        });
      });

      acceptButton?.addEventListener('click', () => finishPurchase(true));
      declineButtons.forEach((button) => button.addEventListener('click', () => finishPurchase(false)));
      cancelButton?.addEventListener('click', cancelPurchase);
      dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        cancelPurchase();
      });
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) cancelPurchase();
      });
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-papelia-pricing-section]').forEach(initSection);
    };

    window.PapeliaExclusiveCheckout = { init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
